import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTwitter, FaFacebook, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-text">Taxi</span>
              <span className="logo-highlight">VD</span>
            </div>
            <p className="footer-description">
              Transport de qualité pour tous vos besoins. Service professionnel, 
              fiable et sécurisé dans la région.
            </p>
            <div className="footer-contact">
              <a href="tel:+41797774444" className="contact-item">
                <FaPhone /> +41 79 777 44 44
              </a>
              <a href="mailto:info@taxivd.ch" className="contact-item">
                <FaEnvelope /> info@taxivd.ch
              </a>
              <span className="contact-item">
                <FaMapMarkerAlt /> Suisse
              </span>
            </div>
          </div>

          <div className="footer-section">
            <h3>Navigation</h3>
            <div className="footer-links">
              <Link to="/">Accueil</Link>
              <Link to="/services">Services</Link>
              <Link to="/permis">Permis</Link>
              <Link to="/job">Emploi</Link>
              <Link to="/quote">Devis</Link>
            </div>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <div className="footer-links">
              <Link to="/services/navette-aeroport">Navette Aéroport</Link>
              <Link to="/services/courses-scolaires">Courses Scolaires</Link>
              <Link to="/services/transport-medical">Transport Médical</Link>
              <Link to="/services">Voir tous nos services →</Link>
            </div>
          </div>

          <div className="footer-section">
            <h3>Suivez-nous</h3>
            <div className="social-links">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © {new Date().getFullYear()} TaxiVD — Website by{' '}
            <a href="https://instagram.com/untruemedia" target="_blank" rel="noopener noreferrer">
              Untrue Media
            </a>
          </div>
          <div className="footer-legal">
            <Link to="/privacy">Confidentialité</Link>
            <Link to="/terms">Conditions</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
